import { render } from "./Dialogue.vue?vue&type=template&id=579e94ac&scoped=true&ts=true"
import script from "./Dialogue.vue?vue&type=script&lang=ts"
export * from "./Dialogue.vue?vue&type=script&lang=ts"

import "./Dialogue.vue?vue&type=style&index=0&id=579e94ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579e94ac"]])

export default __exports__